import {Component} from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-our-clients',
  standalone: true,
  imports: [
    NgForOf,
    NgOptimizedImage
  ],
  templateUrl: './our-clients.component.html',
  styleUrl: './our-clients.component.css'
})
export class OurClientsComponent {
  imagenes = [
    {
      url: 'aig.svg',
      alt: 'AIG'
    },
    {
      url: 'asisker.svg',
      alt: 'Asisker'
    },
    {
      url: 'bmi.svg',
      alt: 'BMI'
    },
    {
      url: 'bupa.svg',
      alt: 'Bupa'
    },
    {
      url:'confiamed.svg',
      alt: 'Confiamed'
    },
    {
      url: 'coris.svg',
      alt: 'Cosris'
    },
    {
      url: 'humana.svg',
      alt: 'Humana'
    },
    {
      url: 'latinaSalud.svg',
      alt: 'Latina Salud'
    },
    {
      url: 'libertySeguros.svg',
      alt: 'Liberty Seguros'
    },
    {
      url: 'mawdy.svg',
      alt: 'Mawdy'
    },
    {
      url:'medec.svg',
      alt: 'Medecl'
    },
    {
      url: 'mediken.svg',
      alt: 'Mediken'
    },
    {
      url: 'nesec.svg',
      alt: 'Nesec'
    },
    {
      url: 'panAmericanLife.svg',
      alt: 'Pan American Life'
    },
    {
      url: 'planvital.svg',
      alt: 'Plan Vital'
    },
    {
      url: 'plusmedical.svg',
      alt: 'Plus Medical'
    },
    {
      url: 'prestasalud.svg',
      alt: 'Presta Salud'
    },
    {
      url: 'proassislife.svg',
      alt: 'Proassislife'
    },
    {
      url: 'saludsa.svg',
      alt: 'Saludsa'
    },
    {
      url: 'sweaden.svg',
      alt: 'Sweaden'
    },
    {
      url: 'vidaBuena.svg',
      alt: 'Vida Buena'
    }

  ]

}
